import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-box_bottom_right_icon",
  "use": "icon-box_bottom_right_icon-usage",
  "viewBox": "0 0 30 30.02",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 30 30.02\" id=\"icon-box_bottom_right_icon\"><defs><style>#icon-box_bottom_right_icon .cls-1{fill:none;stroke:#7ce7fd;stroke-miterlimit:10;stroke-width:3px;}</style></defs><title>右下</title><g id=\"icon-box_bottom_right_icon_图层_2\" data-name=\"图层 2\"><g id=\"icon-box_bottom_right_icon_图层_1-2\" data-name=\"图层 1\"><path class=\"cls-1\" d=\"M28.5,0V18.52a10,10,0,0,1-10,10L0,28.46\" /></g></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol